import type { ReactElement } from 'react';
import { BrandLogo } from '@/shared/ui';

interface AboutHeroMediaProps {
  /** HOME 히어로 배너 사진 — 없으면 흑연 판에 흰 로고와 라임 선을 얹는다. */
  readonly imageUrl: string | null;
  /** 배너를 아직 불러오는 중이면 회색 자리만 잡아 둔다(흑연 판이 번쩍이지 않게). */
  readonly isPending: boolean;
}

/** 회사 소개 첫 화면의 큰 사진 칸 — 각진 전폭 판. 장식이라 보조기기에는 읽히지 않는다. */
export const AboutHeroMedia = ({ imageUrl, isPending }: AboutHeroMediaProps): ReactElement => {
  if (isPending) {
    return (
      <div aria-hidden className="aspect-[4/3] w-full animate-pulse bg-muted/70 sm:aspect-[21/9]" />
    );
  }

  if (imageUrl !== null) {
    return (
      <div aria-hidden className="aspect-[4/3] w-full overflow-hidden bg-muted/70 sm:aspect-[21/9]">
        <img src={imageUrl} alt="" className="size-full object-cover" />
      </div>
    );
  }

  return (
    <div
      aria-hidden
      className="flex aspect-[4/3] w-full flex-col items-center justify-center gap-6 bg-primary text-white sm:aspect-[21/9]"
    >
      <BrandLogo className="h-10 sm:h-16" />
      <span className="block h-px w-40 bg-brand-lime sm:w-56" />
    </div>
  );
};
